import gql from 'graphql-tag';

export const COMPANY_BRANCHES_QUERY = gql`
  query companyBranches($id: ID!) {
    companyBranches(id: $id) {
      id
      code
      description
      companyId
    }
  }
`;

export const CREATE_OR_UPDATE_BRANCH_MUTATION = gql`
  mutation createOrUpdateBranch($id: ID, $branchInputDetails: BranchInput!) {
    createOrUpdateBranch(id: $id, branchInput: $branchInputDetails) {
      id
      code
      description
      companyId
    }
  }
`;
